import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    CardGridEstudoPadrao,
} from '../estudo-form/EstudoComp'

import {
    serieVazia
} from './ChartService'



const GraficoBarrasChart = ( { values, setFieldValue, estudo, vars, report, popup, grafico, media, paletaTons, title,
    participacao, tabela, tabelaTitle, zoom, titleZoomTabela, moreLessList, idListaMoreLess, aiFTOrigem, variaveisGlobais } ) => {

    const GraficoBarras = ( /*props*/ ) => {

        const series = []

        const paletaCoresEspecifica = []
    
        grafico?.forEach( (linhaGrafico, index) => {
    
            series.push(
                {
                    name: linhaGrafico.descricao,
                    type: 'bar',
                    data: linhaGrafico.serie,
                    media: media ? media[index].serie : ''
                },
            )
    
            paletaCoresEspecifica.push(
                paletaTons[index]
            )
        })

        serieVazia(series, estudo)
        
        const categories = estudo.current.graficoIdadesGraficos
    
        const GridGrafico = report ? GridItem11 : GridItem11
    
        return (

            //<div
            //    {...props}
            //>
                <GridContainer>
                    <GridGrafico>
                        <ChartPadrao
                            titleText={''} // mudança da fonte: titleText={title}
                            titleTextPopup={title} // mudança da fonte
                            type={"area"}
                            series={series}
                            stacked={true}
                            categories={categories}
                            categories2={estudo.current.graficoAnos}
                            paletaCores={paletaCoresEspecifica}
                            dataLabelsEnabled={values.modoApresentacao && values.tabEstudoFormList === LABEL.relatorio}
                            dataLabelsEnabledReport={values.formatoReport === HARDCODE.idFormatoReportImpressao}
                            dataLabelsType='Idade'
                            dataLabelsDestaque={[values.idadeVaiAposentarCliente + (title === LABEL.consumoReservaAposentadoria ? 1 : 0)]}
                            columnWidth='80%'
                            notInverseOrder={true}
                            //strokeWidth={0}
                            toolTipX={true}
                            toolTipXTotal={true}
                            report={report}
                            formatoReport={values.formatoReport}
                            modoApresentacao={values.modoApresentacao}
                            fillOpacity={0.65}//0.8
                            //fillType='gradient'
                            mediaMensal={true}
                            participacao={participacao}
                            dataSimulacaoEstudo={values.dataSimulacaoEstudo}
                            zoom={zoom}
                            titleZoomTabela={titleZoomTabela}
                        />
                    </GridGrafico>
                </GridContainer>
            //</div>
        )
    }

    return (
        <GridItem12>
            {report || popup
                ?
                    <GraficoBarras
                        //className={(report ? "mt--5" : "mt-0") + " ml-5"} // mudança da fonte: mt-5
                    />
                :
                    <CardGridEstudoPadrao
                        label={
                            !relatorioModoApresentacao(values)
                                ?
                                    title
                                :
                                    HARDCODE.modoApresentacaoRelatorio
                        }
                        component={
                            <div
                                className='ml-10'
                            >
                                <GraficoBarras/>
                            </div>
                        }
                        overflowX={false}
                        tabela={tabela}
                        tabelaTitle={tabelaTitle}
                        modoApresentacao={values.modoApresentacao}
                        nameListaMoreLess={moreLessList}
                        listaMoreLess={moreLessList ? values[moreLessList] : ''}
                        idListaMoreLess={idListaMoreLess}
                        setFieldValue={setFieldValue}
                        aiFTOrigem={aiFTOrigem}
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        estudo={estudo}
                        vars={vars}
                    />
            }
        </GridItem12>
    )
}

export default GraficoBarrasChart